import { render, staticRenderFns } from "./QueueLogs.vue?vue&type=template&id=2273a4b3&scoped=true"
import script from "./QueueLogs.vue?vue&type=script&lang=js"
export * from "./QueueLogs.vue?vue&type=script&lang=js"
import style0 from "./QueueLogs.vue?vue&type=style&index=0&id=2273a4b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273a4b3",
  null
  
)

export default component.exports